// extracted by mini-css-extract-plugin
export default {"header":"StepHeader_header__YK54E","card":"StepHeader_card__-VXPj"};